export default "__VITE_ASSET__DZBOU2de__"